import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  IonIcon,
  IonSpinner
} from '@ionic/angular/standalone';
import { DisplayService, PaginatedResponse } from '@qid/core';
import { CollectionRequest } from '../../interface/collection-request.interface';
import { CollectionRequestService } from '../../services/collection-request.service';
import { Environment, ENVIRONMENT, getEnv } from '@qid/env';

@Component({
  selector: 'list-collection-request',
  templateUrl: './list-collection-request.component.html',
  styleUrls: ['./list-collection-request.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonIcon,
    IonSpinner,
  ],
})
export class ListCollectionRequestComponent implements OnInit {


  public paginatedResponse: PaginatedResponse<CollectionRequest> = { docs: [] };

  loading = false;
  error: string | null = null;

  @Output() collectionRequestSelected = new EventEmitter<CollectionRequest>();

  collectUrl = '';

  constructor(
    private collectionRequestService: CollectionRequestService,
    private displayService: DisplayService,
    private router: Router,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    this.error = null;
    try {
      const res = await this.collectionRequestService.readAll();
      if (res.data) {
        this.paginatedResponse = res.data;
      }

    } catch (e) {
      this.error = e instanceof Error ? e.message : 'Failed to load collection requests';
      this.paginatedResponse = { docs: [] };
    } finally {
      this.loading = false;
    }
  }

  upsert(request: CollectionRequest, templatePurpose?: string): void {
    let entry = request;
    if (!entry.template?.purpose) {
      const existingTemplate = (this.paginatedResponse.docs ?? []).find(
        (item) => item.templateId === entry.templateId && item.template?.purpose,
      )?.template;
      entry = {
        ...entry,
        template: existingTemplate ?? {
          ...(entry.template ?? {}),
          _id: entry.templateId,
          purpose: templatePurpose ?? '',
        } as CollectionRequest['template'],
      };
    }

    const docs = [...(this.paginatedResponse.docs ?? [])];
    const index = docs.findIndex((item) => item._id === entry._id);
    if (index >= 0) {
      docs[index] = entry;
    } else {
      docs.unshift(entry);
    }
    this.paginatedResponse = { ...this.paginatedResponse, docs };
  }

  onItemClick(request: CollectionRequest): void {
    this.collectionRequestSelected.emit(request);
    void this.router.navigate(['/menu/collection-request', request._id]);
  }

  trackById(_index: number, item: CollectionRequest): string {
    return item._id;
  }

  onCopyLink(id: string): void {
    navigator.clipboard.writeText(this.getCollectUrl(id));
    this.displayService.toast({ message: 'Link copied to clipboard' });
  }

  getCollectUrl(id: string): string {
    // Remove trailing 'rt/' if present in collectUrl
    this.collectUrl = this.environment.collectUrl;
    let baseUrl = this.collectUrl.endsWith('rt/') ? this.collectUrl.slice(0, -3) : this.collectUrl;
    // Also, ensure there's no trailing slash before appending '/request/'
    baseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return baseUrl + '/request/' + id;
  }
}
